import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

import {DefaultFoundationTheme, ThemeColorTextPath} from './foundationTheme';
import {getThemeValue} from './getThemeValue';

export function getTextColorByPath(
  color: ThemeColorTextPath | Nullish,
  theme: DefaultFoundationTheme
): string | undefined {
  if (isNil(color)) {
    return undefined;
  }
  return getThemeValue<string>(theme.colors.text, color);
}
